<template>
  <iframe ref="external" style="width: 100%;height: 100%;" :src="src"></iframe>
</template>

<script>
export default {
  name: "External",
  computed: {
    src() {
      return this.$route.query.url;
    }
  }
};
</script>

<style scoped>

</style>
